import { supabase } from "@/integrations/supabase/client";

/**
 * Returns all leaders currently in a coach's scope.
 * Source of truth is coach_leader_links.
 */
export async function getCoachLeaderIds(coachId: string): Promise<string[]> {
  const linkResult = await supabase
    .from("coach_leader_links")
    .select("leader_id")
    .eq("coach_id", coachId);

  if (linkResult.error) throw linkResult.error;

  const ids = new Set<string>();
  (linkResult.data || []).forEach((row) => ids.add(row.leader_id));
  return Array.from(ids);
}

export async function isLeaderAssignedToCoach(coachId: string, leaderId: string): Promise<boolean> {
  const linkResult = await supabase
    .from("coach_leader_links")
    .select("leader_id")
    .eq("coach_id", coachId)
    .eq("leader_id", leaderId)
    .maybeSingle();

  if (linkResult.error) throw linkResult.error;

  return Boolean(linkResult.data);
}
